import React from 'react'


class PageHead extends React.Component{

	render(){ 

		const {set, currentPage, totalPages} = this.props

		return(			
					
			<div className='printPackPageHead'>		
				{set && 	
					<div className='printPackPageHead-name'>
						{set.name}
					</div>
				}
				<div className='printPackPageHead-pageNumbers'>
					{currentPage && 
						<div className='printPackPageHead-pageNumbers-current'>
							{currentPage}
						</div>
					}
					{totalPages && 
						<div className='printPackPageHead-pageNumbers-total'>
							 &nbsp;/ {totalPages}
						</div>
					}
				</div>

			</div>
			
		)
	}
}
export default PageHead